/* INTEGY V688 — final native collection pagination guard.
   Repairs page-number / Next / Previous hrefs after filtered collection state
   scripts run. Excludes custom large/indexed pagination owners. */
(function () {
  'use strict';
  if (window.IntegyV688PaginationGuard) return;
  window.IntegyV688PaginationGuard = true;

  var PAGERS = '.pagination--container,.productgrid--pagination,.pagination-wrapper';
  var OWNED = '[data-integy-v651-large-pagination],.integy-v426-filter-pagination,[data-integy-v664-demand-pagination]';
  var queued = false;

  function collectionPage() {
    return !!(document.body && document.body.classList.contains('template-collection')) || /^\/collections\//i.test(location.pathname || '');
  }

  function nativePager(anchor) {
    if (!anchor || !anchor.closest) return null;
    var pager = anchor.closest(PAGERS);
    if (!pager || pager.matches(OWNED) || anchor.closest(OWNED)) return null;
    return pager;
  }

  function currentPage() {
    try {
      var n = Number(new URL(location.href).searchParams.get('page') || 1);
      if (isFinite(n) && n > 0) return Math.floor(n);
    } catch (e) {}
    var active = document.querySelector(PAGERS + ' [aria-current="page"], ' + PAGERS + ' [aria-current="true"], ' + PAGERS + ' .pagination--active');
    var m = String(active && active.textContent || '').match(/\d+/);
    return m ? Number(m[0]) : 1;
  }

  function targetPage(anchor) {
    if (!anchor) return 0;
    var label = String(anchor.getAttribute('aria-label') || anchor.getAttribute('title') || anchor.textContent || '').replace(/\s+/g, ' ').trim();
    var number = label.match(/(?:^|\b)(?:go\s+to\s+)?page\s*(\d+)(?:\b|$)/i) || label.match(/^\s*(\d+)\s*$/);
    if (number) return Math.max(1, Number(number[1]));
    var cur = currentPage();
    if (/\bnext\b/i.test(label) || anchor.rel === 'next') return cur + 1;
    if (/\b(prev|previous)\b/i.test(label) || anchor.rel === 'prev') return Math.max(1, cur - 1);
    return 0;
  }

  function canonicalHref(page) {
    try {
      var url = new URL(location.href);
      if (page > 1) url.searchParams.set('page', String(page));
      else url.searchParams.delete('page');
      return url.pathname + (url.search ? '?' + url.searchParams.toString() : '') + url.hash;
    } catch (e) { return ''; }
  }

  function repairAnchor(anchor) {
    if (!nativePager(anchor)) return;
    var page = targetPage(anchor);
    if (!page) return;
    var href = canonicalHref(page);
    if (!href) return;
    if (anchor.getAttribute('href') !== href) anchor.setAttribute('href', href);
    anchor.setAttribute('data-integy-v688-page', String(page));
  }

  function repair(scope) {
    if (!collectionPage()) return;
    var root = scope && scope.querySelectorAll ? scope : document;
    Array.prototype.forEach.call(root.querySelectorAll(PAGERS + ' a[href]'), repairAnchor);
    if (scope && scope.matches && scope.matches(PAGERS + ' a[href]')) repairAnchor(scope);
  }

  function schedule() {
    if (queued) return;
    queued = true;
    (window.requestAnimationFrame || function (fn) { return setTimeout(fn, 16); })(function () {
      queued = false;
      repair(document);
    });
  }

  function clickGuard(event) {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    var anchor = event.target && event.target.closest ? event.target.closest(PAGERS + ' a[href]') : null;
    if (!anchor || !nativePager(anchor)) return;
    var page = targetPage(anchor);
    if (!page || page === currentPage()) return;
    var href = canonicalHref(page);
    if (!href) return;

    /* Own this final click so an older delegated pagination/filter listener cannot
       strip page=N after V688 has repaired the href. Full navigation is deliberate:
       Shopify then renders the requested filtered page authoritatively. */
    event.preventDefault();
    event.stopImmediatePropagation();
    location.assign(href);
  }

  function boot() {
    if (!collectionPage()) return;
    repair(document);
    document.addEventListener('click', clickGuard, true);
    if (window.MutationObserver) {
      new MutationObserver(schedule).observe(document.body || document.documentElement, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['href']
      });
    }
    window.addEventListener('pageshow', schedule);
    document.addEventListener('shopify:section:load', schedule);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();
